import { FC, ReactNode } from 'react'
import styles from './EditPagesHead.module.scss'
import { Button } from '@mui/material'

type EditPagesHeadProps = {
  title: string
  Icon: ReactNode
  button?: {
    endIcon?: ReactNode
    startIcon?: ReactNode
    onClick: () => void
    text: string
  }
}

export const EditPagesHead: FC<EditPagesHeadProps> = ({
  title,
  Icon,
  button,
}) => {
  return (
    <div className={styles.formHeader}>
      <div className={styles.title}>
        {Icon && Icon}
        <span className='h1'>{title}</span>
      </div>
      {button && (
        <Button
          className={styles.headerButton}
          endIcon={button.endIcon}
          startIcon={button.startIcon}
          onClick={button.onClick}
          data-testid='user-data-back'
        >
          {button.text}
        </Button>
      )}
    </div>
  )
}
